import { RemoteCreateProfessionalManagement } from 'data/usecases/professionals';
import { CreateProfessionalManagementUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsManager } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateProfessionalManagement =
  (): CreateProfessionalManagementUseCaseInterface =>
    new RemoteCreateProfessionalManagement(
      makeApiUrlProfessionalsManager(),
      makeAxiosHttpClient(),
    );
